import { findPartials } from "jose_modern/replace_partial.js";
import { onViewLoad } from "jose_modern/on_view_load.js";
import { initCollapsibleTables } from "jose_modern/collapsed_table.js";

/* Locate all RecipeIngredient TRs that are expanded */
const getExpandedRecipeIngredients = () => {
  return Array.from(findPartials("recipes/recipe_ingredient_table_row"))
    .filter((tr) => tr.classList.contains("is-expanded"))
    .map((tr) => tr.dataset.instance);
};

/* expand RecipeIngredient TRs with the ids in recipeIngredientIds */
const setExpandedRecipeIngredients = (recipeIngredientIds) => {
  const ids = recipeIngredientIds.map((id) => id.toString());

  Array.from(findPartials("recipes/recipe_ingredient_table_row"))
    .filter((tr) => ids.includes(tr.dataset.instance))
    .forEach((tr) => {
      tr.classList.add("is-expanded");
      tr.classList.remove("is-collapsed");
    });
};

onViewLoad("recipes#edit", () => {
  Object.assign(globalThis, {
    getExpandedRecipeIngredients,
    setExpandedRecipeIngredients,
  });

  initCollapsibleTables(document);
});
